import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  Typography,
} from '@material-ui/core';
import { PipelinePrResult } from '@internal/backstage-plugin-sql-pipeline-common';

/** `https://github.com/yogiyo/dp-lakehouse/pull/2092` → `yogiyo/dp-lakehouse#2092` */
export function prLabel(url: string, number: number): string {
  const m = url.match(/github\.com\/([^/]+\/[^/]+)\/pull\//);
  return m ? `${m[1]}#${number}` : `#${number}`;
}

/**
 * PR 을 만든 뒤의 결과 화면. 한때 성공 알림(`alertApi`)으로 PR 번호만 띄우고
 * 다이얼로그를 닫았는데, 알림은 문자열만 받아 링크를 걸 수 없어 GitHub 에서 번호로
 * 다시 찾아야 했다(사용자 지적). 다이얼로그를 닫지 않고 PR 링크를 보여준다.
 *
 * Airflow DAG PR 만 보여준다. 카탈로그 PR 은 백엔드 CatalogFollower 가 DAG PR 의
 * 결과를 따라 머지·닫으므로 사용자가 볼 일이 없다 — 링크가 있으면 그것도 머지해야
 * 하는 줄 안다.
 */
export const PrCreatedDialog = (props: {
  open: boolean;
  onClose: () => void;
  title: string;
  result: PipelinePrResult;
  /**
   * 머지 뒤 안내 — 생성·수정·삭제마다 다르다. 목록 반영 시간은 「평균」 으로 적는다:
   * CatalogFollower 주기(2 분)와 카탈로그 수집 주기(1 분)를 더하면 최대 3 분 남짓이지만,
   * 「최대」 라고 적으면 조금만 늦어도 실패로 읽힌다(사용자 지적).
   */
  outcome: string;
}) => {
  const { result } = props;
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          {'Airflow DAG PR — '}
          <Link href={result.dagPrUrl} target="_blank" rel="noopener noreferrer">
            {prLabel(result.dagPrUrl, result.dagPrNumber)}
          </Link>
        </Typography>
        <Box my={1.5}>
          <Typography variant="body1">
            체크가 모두 진행된 후 머지버튼을 눌러서 반영해주세요.
          </Typography>
          <Typography variant="body1">{props.outcome}</Typography>
        </Box>
        <Typography variant="body2" color="textSecondary">
          문의: #help_data
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose} color="primary" variant="contained">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};
